import { render, staticRenderFns } from "./home-estates-item.vue?vue&type=template&id=6dbd480d&scoped=true&"
import script from "./home-estates-item.vue?vue&type=script&lang=js&"
export * from "./home-estates-item.vue?vue&type=script&lang=js&"
import style0 from "./home-estates-item.vue?vue&type=style&index=0&id=6dbd480d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbd480d",
  null
  
)

export default component.exports